<a
  *ngIf="personId; else unlinkedReference"
  class="member-reference member-reference--linked"
  [routerLink]="['/people', personId]"
  (click)="onClick($event)">
  <span>{{ name }}</span>
  <span *ngIf="isDeceased" class="member-reference__deceased" aria-label="Fallecido/a" title="Fallecido/a">†</span>
</a>

<ng-template #unlinkedReference>
  <span class="member-reference member-reference--unlinked" title="Sin ficha asociada">
    <span>{{ name }}</span>
    <span *ngIf="isDeceased" class="member-reference__deceased" aria-label="Fallecido/a" title="Fallecido/a">†</span>
  </span>
</ng-template>
